import './shannondell2/style';
import FormStructure from './shannondell2/form_structure';

export default FormStructure;